import type { RootState } from '@generalTypes/rootStateTypes';
import { KovResourcePicker } from '@kathondvla/react-shared-components/src/components';
import type {
  DropDownOptionsType,
  EditAsideAttachmentGroupType,
} from '@nodeTypeConfig/configTypes';
import { patchNodeAction } from '@store/actions/documentActions';
import { getResourceKey } from '@store/helpers/documentHelpers';
import { any } from 'prop-types';
import type React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEditHref } from '../../../hooks/UseEditHref';
import { selectCurrentAttachmentGroupType } from './asideAttachmentGroupSelectors';

const AsideAttachmentGroupType: React.FC<{
  config: EditAsideAttachmentGroupType;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const dispatch = useDispatch();
  const editHref = useEditHref();

  const selectedOption: DropDownOptionsType = useSelector((state: RootState) =>
    selectCurrentAttachmentGroupType(state, config),
  );

  const onChange = (value: DropDownOptionsType) => {
    const importance = value.key;

    dispatch(patchNodeAction(getResourceKey(editHref), { importance }));
  };

  return (
    <div style={{ maxWidth: '400px' }}>
      <label className="control-label">{config.label}</label>
      {config.subLabel && <label className="subtitle-label">{config.subLabel}</label>}

      <KovResourcePicker
        value={selectedOption}
        localData={config.options}
        disabled={readonly}
        clearable={false}
        onChange={onChange}
        menuPlacement="bottom"
        disableSearch={true}
        optionValue={(o: DropDownOptionsType) => o.key}
        optionTemplate={(o: DropDownOptionsType) => o.label}
      />
    </div>
  );
};

export default AsideAttachmentGroupType;

AsideAttachmentGroupType.displayName = 'AsideAttachmentGroupType';

AsideAttachmentGroupType.propTypes = {
  config: any,
  readonly: any,
};
